import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { walletMainWhitelist } from "../../rbac-consts";
import AdminWalletMainWhitelistContainer from "./admin/WalletMainWhitelistContainer";

const WalletMainWhitelistWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={walletMainWhitelist.ADMIN}
        yes={() => (
          <AdminWalletMainWhitelistContainer match={match} />
        )}
      />
    </>
  );
};

export default WalletMainWhitelistWrapper;